import { createAction, props, Action } from '@ngrx/store';
import { Role } from '@models';

export const Add = createAction('[Role Component] Add');
export const Remove = createAction('[Role Component] Remove');
export const GetList = createAction('[Role Component] GetList');
export const GetListSuccess = createAction(
  '[Role Component] GetListSuccess',
  props<{data: Role[]}>()
);

// export enum RoleActionTypes {
//   Add = '[Role Component] Add',
//   Remove = '[Role Component] Remove',
//   GetList = '[Role Component] GetList',
//   GetListSuccess = '[Roles Component] GetListSuccess',
// }

// export class ActionEx implements Action {
//   readonly type: string;
//   payload: any;
// }

// export class RoleAdd implements ActionEx {
//   readonly type = RoleActionTypes.Add;

//   constructor(public payload: any) { }
// }

// export class RoleRemove implements ActionEx {
//   readonly type = RoleActionTypes.Remove;

//   constructor(public payload: any) { }
// }

// export class RoleGetList implements ActionEx {
//   readonly type = RoleActionTypes.GetList;

//   constructor(public payload: any) {
//     payload = null;
//   }
// }

// export class RoleGetListSuccess implements ActionEx {
//   readonly type = RoleActionTypes.GetListSuccess;

//   constructor(public payload: any) { }
// }
